import { Order } from "./Order";
import { ResponseReportConfirm } from "./ResponseReportConfirm";
import { ResponseReportOrder } from "./ResponseReportOrder";
import { ResponseReportOrderAddress } from './ResponseReportOrderAddress';
import { ResponseReportOrderFinished } from "./ResponseReportOrderFinished";
import { ResponseReportOrderPreparation } from "./ResponseReportOrderPreparation";
import { ResponseReportReturns } from "./ResponseReportReturns";
import { ResponseReportSales } from "./ResponseReportSales";
import { ResponseReportStock } from "./ResponseReportStock";
import { ResponseReportStore } from "./ResponseReportStore";
import { SearchReport } from "./SearchReport";

export class ReportOrder {
    searchReport : SearchReport;
    responseReportSales : ResponseReportSales [];
	responseReportOrder : ResponseReportOrder [];
    responseReportOrderFinished : ResponseReportOrderFinished [];
    responseReportOrderPreparation : ResponseReportOrderPreparation [];
    responseReportStore : ResponseReportStore [];
    responseReportAddressOrder: ResponseReportOrderAddress[];
    responseReportConfirm : ResponseReportConfirm[];
    responseReportStock : ResponseReportStock[];
    responseReportReturns : ResponseReportReturns[];
    orders: Order[];
    token: String;
    errorCode: {
        message: string,
        code: string
    }    
}